export const DealTypeOptions = [
    { label: 'New', value: 'new' },
    { label: 'Graduation', value: 'graduation' },
    { label: 'Complementary', value: 'complementary' },
    { label: 'Renewal', value: 'renewal' },
    { label: 'Draw', value: 'draw' },
    { label: 'Stacked', value: 'stacked' },
    { label: 'Renewal Complementary', value: 'renewalComplementary' },
    { label: 'Renewal Graduation', value: 'renewalGraduation' }
];
